export default "__VITE_ASSET__Dl0JMxi5__"